var map = {
	"./campfire.mp3": 4147,
	"./forest.mp3": 4148,
	"./ocean.mp3": 4149,
	"./river.mp3": 4150,
	"./savanna.mp3": 4151,
	"./storm.mp3": 4152
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 711;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/background .\.mp3*
// module id = 711
// module chunks = 0